import { useEffect, useState } from "react";

/** Teclado virtual aberto: a área visível encolhe bem mais que uma barra de endereço some (~150px). */
export function useTecladoAberto(): boolean {
  const [aberto, setAberto] = useState(false);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const medir = () => setAberto(window.innerHeight - vv.height > 150);
    vv.addEventListener("resize", medir);
    return () => vv.removeEventListener("resize", medir);
  }, []);
  return aberto;
}
